export const get_achievements = (state) => state.achievements;

export const get_achievement = (state) => state.achievement;
